import { render } from "./aboutDih.vue?vue&type=template&id=831a9974&scoped=true"
import script from "./aboutDih.vue?vue&type=script&lang=js"
export * from "./aboutDih.vue?vue&type=script&lang=js"

import "./aboutDih.vue?vue&type=style&index=0&id=831a9974&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-831a9974"]])

export default __exports__